var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { GET_CALL_HISTORY_SUCCESS, SET_CALL_HISTORY_PARAMS } from './call-history.actions';
export var initialState = {
    total: null,
    calls: [{}],
    params: {
        sortBy: 'callTime',
        order: 'DESC',
        pager: {
            pageIndex: 0,
            pageSize: 10,
            previousPageIndex: 0
        }
    }
};
export function callHistoryReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_CALL_HISTORY_SUCCESS:
            return __assign({}, state, { calls: action.payload.data, total: action.payload.total });
        case SET_CALL_HISTORY_PARAMS:
            return __assign({}, state, { params: action.payload });
        default: {
            return state;
        }
    }
}
export var getCallHistoryPage = function (state) { return state.callHistory; };
export var getCalls = function (callHistoryState) { return callHistoryState.calls; };
export var getTotal = function (callHistoryState) { return callHistoryState.total; };
export var getParams = function (callHistoryState) { return callHistoryState.params; };
export var getCallHistoryCallsSelector = createSelector(getCallHistoryPage, getCalls);
export var getCallHistoryTotalSelector = createSelector(getCallHistoryPage, getTotal);
export var getCallHistoryPageSelector = createSelector(getCallHistoryPage, getParams);
